export default __webpack_public_path__ + "static/media/WAS0070.34I-35323_-20472_0.df51c5a0.jpg";